import React from "react";
interface DownloadIconProps {
  color?: string;
  size?: string;
}

const DownloadIcon: React.FC<DownloadIconProps> = ({
  color = "#79808A",
  size = "24",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 14.6667V18.2222C20 18.6937 19.8127 19.1459 19.4793 19.4793C19.1459 19.8127 18.6937 20 18.2222 20H5.77778C5.30628 20 4.8541 19.8127 4.5207 19.4793C4.1873 19.1459 4 18.6937 4 18.2222V14.6667M17 8.44444C17 8.44444 13.7357 12.931 12 14.6667M12 14.6667C10.2643 12.931 7 8.44444 7 8.44444M12 14.6667C12 10.5011 12 8.16559 12 4"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DownloadIcon;
